import { API } from "../api";
import { url } from "../constants";
import {
  IAuthAPIService,
  IConfirmPasswordRecoveryRequestData,
  ILoginRequestData,
  ILoginResponseData,
  IRefreshTokenRequestData,
  IRefreshTokenResponseData,
  IResetPasswordRequestData,
} from "./types";

export class AuthAPIService implements IAuthAPIService {
  constructor(private api: API) {}

  async login(data: ILoginRequestData) {
    const response = await this.api.post<ILoginResponseData>(
      url.principal.login,
      data,
    );
    return response.data;
  }

  async refreshToken(data: IRefreshTokenRequestData) {
    const response = await this.api.post<IRefreshTokenResponseData>(
      url.principal.refresh,
      data,
    );
    return response.data;
  }

  async resetPassword(data: IResetPasswordRequestData) {
    await this.api.post(url.principal.resetPassword, data);
  }

  async confirmPassword(data: IConfirmPasswordRecoveryRequestData) {
    await this.api.post(url.principal.confirmPasswordRecovery, data);
  }
}
